import Vue from 'vue';
import {requestTimeBury} from '../../views/main/bury';
import {fetchData, parseJson, getPointBound} from '../../utils';
import {getShareData} from '../../views/main/initWxConfig';

export default {
    namespaced: true,

    state: {
        // 数据加载完成标记
        finishedFlag: false,
        firstFeedFinish: false, // 首篇是否加载完成
        // page number
        pn: 0,
        // 列表数据
        dataList: [],
        requestTime: Date.now(),
        firstIsForewarning: false,
        // 微详情顶部的poi信息
        topPoiInfo: {},
        // 数据加载失败
        error: false,
        // 预加载底部按钮展开动画
        showSpaceCompressFoldPart: false,
        isFromMap: false, // 是否从地图点击
        mapBound: '', // 微信内地图的戳点边界区域
        isMapFeedFinished: false, // 微信内地图的笔记是否加载完成
        microPoiDetail: {}, // 微信内poi点信息
        // 评论&笔记数据加载完成标记
        commentFinishedFlag: false,
        commenIndex: 0 // 记录评论转笔记，评论当前最大index
    },

    getters: {
        finishedFlag: state => state.finishedFlag,
        pn: state => state.pn,
        dataList: state => state.dataList,
        requestTime: state => state.requestTime,
        topPoiInfo: state => state.topPoiInfo,
        error: state => state.error,
        showSpaceCompressFoldPart: state => state.showSpaceCompressFoldPart,
        isFromMap: state => state.isFromMap,
        mapBound: state => state.mapBound,
        isMapFeedFinished: state => state.isMapFeedFinished,
        microPoiDetail: state => state.microPoiDetail,
        firstFeedFinish: state => state.firstFeedFinish,
        commentFinishedFlag: state => state.commentFinishedFlag,
        commenIndex: state => state.commenIndex
    },

    mutations: {
        setFinishedFlag(state, flag) {
            state.finishedFlag = flag;
        },
        setPn(state, pn) {
            state.pn = pn;
        },
        setDataList(state, params = {}) {
            let {data = [], iframePreload = false} = params;
            // 携程预加载会在首屏接口回来数据merge的时候清掉iframe的src，需要单独merge
            if (iframePreload && state.dataList && state.dataList.length === 1 && data.length >= 1) {
                // 接口返回数据的第一项，需要把除thirdUrl之外的所有值，merge到预加载创建的数据中
                const firstData = JSON.parse(JSON.stringify(data[0] || {}));
                delete firstData?.body?.thirdUrl;
                data[0] = Object.assign(state.dataList[0], firstData);
            }
            state.dataList = data;
        },
        updateDataList(state, data) {
            let {dataIndex = -1, val = {}, iframePreload = false} = data;
            if (dataIndex < 0 || dataIndex >= state.dataList.length) {
                return;
            }
            // 预加载场景，底部bar交互刷新数据时，需要注意thirdUrl不能直接merge
            if (iframePreload && dataIndex === 0 && state.dataList.length > 0 && state.dataList[0]?.body?.thirdUrl !== '') {
                delete val?.body?.thirdUrl;
                val = Object.assign(state.dataList[dataIndex], val);
            }
            Vue.set(state.dataList, dataIndex, val);
        },
        setFirstIsForewarning(state, data) {
            state.firstIsForewarning = data;
        },
        setTopPoiInfo(state, poi) {
            state.topPoiInfo = poi;
        },
        setError(state, error) {
            state.error = error;
        },
        setSpaceCompressFoldPart(state, data) {
            state.showSpaceCompressFoldPart = data;
        },
        setFromMap(state, data) {
            state.isFromMap = data;
        },
        setMapBound(state, data) {
            state.mapBound = data;
        },
        setFirstFeedFinish(state, data) {
            state.firstFeedFinish = data;
        },
        setMapFeedFinished(state, data) {
            state.isMapFeedFinished = data;
        },
        setMicroPoiDetail(state, data = {}) {
            state.microPoiDetail = parseJson(data);
        },
        setCommentFinishedFlag(state, flag) {
            state.commentFinishedFlag = flag;
        },
        setCommenIndex(state, index) {
            state.commenIndex = index;
        }
    },

    actions: {
        /**
         * 微详情列表数据接口
         * dataType === 'poicomment' 评论转笔记，dataType === 'feed' 笔记
         */
        async requireData({state, commit, rootState, dispatch}, params) {
            const {pn, unique_id = '', refreshBar = false, dataType = 'feed', firstNode = false} = params || {};
            // 首屏耗时统计用
            if (!rootState.firstScreen.JSInit_endtime) {
                this.commit('firstScreen/setJSInitEndTime', Date.now());
                this.commit('firstScreen/setJSInit_cost', rootState.firstScreen.JSInit_endtime - rootState.firstScreen.JSInit_starttime);
            }
            // 接口耗时统计
            const requestStartTime = Date.now(); // 可直接移动
            if (refreshBar) {
                this.commit('url/setDataType', dataType);
            }
            let url = '';
            if (rootState.url.dataType === 'poicomment') {
                url = '/feed-server/feed/poicomment';
            }
            else {
                url = '/feed/govui/rich_content';
            }
            const {
                os = '',
                sv = '',
                cuid = '',
                c: loc_city_id = '',
                roam_c: bound_city_id = '',
                zid = '',
                auth = ''
            } = rootState.phoneInfo || {};
            let {b: bound = ''} = rootState.phoneInfo || {};
            const source = rootState.url.dataType === 'poicomment' ? 'poi_comment' : (rootState.url.source || 'domainMap');
            try {
                const {apiInfo = '', note_theme = ''} = rootState.url.urlParams;

                let abtest = rootState.url.abtest;
                if (!abtest && rootState.phoneInfo.abtest) {
                    abtest = decodeURIComponent(rootState.phoneInfo.abtest);
                }
                let {
                    loc_x = '',
                    loc_y = ''
                } = rootState.url.pointPosition || {};

                if (!loc_x && !loc_y) {
                    loc_x = rootState.phoneInfo.loc_x;
                    loc_y = rootState.phoneInfo.loc_y;
                }
                const topic = rootState.url.urlParams.topic || 'default';

                let params = {
                    // 第一篇笔记的id
                    insert_list: pn > 0 ? '' : rootState.url.firstUnique_id,
                    from: 'post_detail_feed',
                    note_theme,
                    topic,
                    source,
                    cuid: cuid || '',
                    os,
                    sv,
                    loc_x,
                    loc_y,
                    loc_city_id,
                    // bound,
                    bound_city_id,
                    pn,
                    rn: 4,
                    abtest,
                    timestamp: state.requestTime,
                    zid,
                    auth
                };
                // push全民预警非首屏增加参数
                if (pn > 0) {
                    params.is_qmyj = state.firstIsForewarning ? 1 : 0;
                }
                // 如果端外微信环境，取分享链接参数share_poi_uid
                const uid = rootState.url.wxShareUid ? rootState.url.wxShareUid : rootState.url.uid;
                if (rootState.url.dataType !== 'poicomment') {
                    params.unique_id = rootState.url.firstUnique_id;
                    params.rqt = 6;
                    if (uid) {
                        params.uid = uid;
                        params.rqt = 5;
                    }
                }
                if (unique_id && refreshBar) {
                    params.insert_list = unique_id;
                    params.unique_id = unique_id;
                    params.rn = 1;
                }
                if (rootState.url.dataType === 'poicomment') {
                    params.uid = rootState.url.uid;
                    params.insert_id = rootState.url.firstUnique_id;
                    // 每次请求都要携带url中传入的index值
                    params.index = parseInt(rootState.url.urlParams.index, 10);
                    params.poi_std_tag = rootState.url.urlParams.stdTag;
                    // 评论召回笔记，0是评论，1是笔记
                    params.data_type = state.commentFinishedFlag ? 1 : 0;

                }
                if (refreshBar && rootState.url.dataType === 'poicomment') {
                    params.insert_id = unique_id;
                    // 刷新当条数据对应的index
                    // params.index = rootState.commentNoteIndex; // todo
                    params.index = 0;
                }
                if (apiInfo) {
                    params.apiInfo = apiInfo;
                }
                // 首篇笔记加速接口请求参数，可以更快返回首篇笔记数据
                if (firstNode) {
                    params = {
                        from: 'post_detail_article',
                        unique_id: rootState.url.firstUnique_id,
                        source: rootState.url.source,
                        cuid: cuid || '',
                        os,
                        sv,
                        timestamp: state.requestTime,
                        apiInfo,
                        abtest,
                        uid
                    };
                }
                params.bound = state.mapBound || bound;
                // 微信内，地图戳点 将unique_id和insert_list设置为空
                if (state.isFromMap) {
                    params.unique_id = '';
                    params.insert_list = '';
                }

                return fetchData(url, {
                    method: 'get',
                    params
                }).then(res => {
                    const {errno} = res || {};
                    let {
                        notes: {content = [], remain_num = 0, user_info = {}} = {},
                        poi = {}
                    } = res && res.data || {};
                    // // 首屏返回时间
                    content = !content ? [] : content;
                    if (!rootState.firstScreen.dataLoad_endtime) {
                        this.commit('firstScreen/setDataLoadEndTime', Date.now());
                        // 首屏接口响应耗时
                        const requestCost = rootState.firstScreen.dataLoad_endtime - rootState.firstScreen.JSInit_endtime;
                        this.commit('firstScreen/setDataLoadCost', requestCost);
                    }
                    // 接口返回时间
                    const requestEndTime = Date.now();
                    requestTimeBury(requestStartTime, requestEndTime, rootState.url.dataType === 'poicomment', firstNode);
                    const {UserID = 0} = user_info || {};
                    if (rootState.url.dataType === 'poicomment' && !rootState.login.isLogin) {
                        this.commit('login/setIsLogin', UserID !== 0);
                    }
                    if (errno === 0) {
                        // 有unique_id说明是刷新某一条数据
                        // 单篇笔记请求pn不累计相加
                        if (!unique_id && !firstNode) {
                        // if (!this.unique_id && !firstNode) { 还是？ !unique_id && !firstNode
                            commit('setPn', state.pn + 1);
                        }
                        if (remain_num === 0 && !firstNode) {
                            let url = rootState.url;
                            // 是评论转笔记&&评论列表标识为false，会把pn强制为0去请求召回笔记数据
                            if (url.dataType === 'poicomment' && !state.commentFinishedFlag) {
                                commit('setCommentFinishedFlag', true);
                                let commentIndex = state.dataList?.length + content?.length - 1;
                                commit('setCommenIndex', commentIndex);
                                params.pn = 0;
                                dispatch('getDataList', params);
                            }
                            // 是召回笔记&&是第一屏请求&&评论列表标识为true，会关闭评论结束标识&&打开内容结束标识
                            else if (params.data_type === 1 && params.pn === 0 && state.commentFinishedFlag) {
                                commit('setCommentFinishedFlag', false);
                                commit('setFinishedFlag', true);
                            }
                            else {
                                // 如果列表只有一项数据，可能会出现loading不消失的情况，所以在请求结束时重置loading状态
                                this.commit('setShowLoading', false);
                                commit('setFinishedFlag', true);
                            }

                        }
                        if (!Object.keys(state.topPoiInfo).length && Object.keys(poi).length) {
                            commit('setTopPoiInfo', poi);
                        }
                        commit('setFirstFeedFinish', true);
                        return content;
                    }
                }).finally(() => {
                    if (!firstNode) {
                        commit('setMapFeedFinished', true);
                    }
                });
            }
            catch (e) {
                commit('setError', true);
                new Vue().$toast({
                    message: '网络繁忙，请稍后再试'
                });
            }
        },
        // 数据处理
        handleData({commit, state, rootState}, params) {
            const {data, index = 0, refreshBar = false, init = false} = params || {};
            if (!data) {
                return;
            }
            data.forEach((item, index) => {
                const {
                    actionBar: {
                        author = {}
                    } = {},
                    body: {
                        thirdUrl = '',
                        article = {},
                        cover = {},
                        favorite = {},
                        like = {},
                        comment_num = 0,
                        user_info = {},
                        skus_data = [],
                        reply = {}
                    } = {},
                    mentioned: {
                        title = '',
                        baseMapButton = {},
                        content = []
                    } = {},
                    guide: {
                        bury = {}
                    } = {},
                    log_id = '',
                    unique_id = '',
                    strategyInfo = '',
                    tpl_type = 'feed',
                    uid: commentUid = '',
                    former_source = '',
                    data_type = 1,
                    hotspot = {}
                } = item || {};
                let aiPush = '';
                if (index === 0) {
                    const {body: aiBody = {}} = item;
                    const {content_type = ''} = aiBody;
                    if (content_type && content_type === 'ai_tourist_guide') {
                        aiPush = 'ai_tourist_guide';
                    }
                }
                const {
                    provider: {tpSource = ''} = {},
                    subSource = '',
                    isQmyj = 0,
                    pushScrId = '',
                    pushCategory = '',
                    tpSource: newtpSource = ''
                } = author || {};
                const {
                    stdTag = '',
                    levelOne = '',
                    levelTwo = ''
                } = bury || {};
                const {num = 0} = reply || {};
                let {headline: wxTitle, content: wxDesc} = article || {};
                const {src: pic = ''} = cover || {};
                let {
                    x = '',
                    y = '',
                    bury: {uid = ''}
                } = content && content[0] || {bury: {}};
                item.shareObj = {
                    wxTitle,
                    wxDesc,
                    pic,
                    unique_id,
                    tpSource: newtpSource || tpSource,
                    subSource,
                    favorite,
                    like,
                    log_id,
                    isForewarning: Number(isQmyj) || 0,
                    stdTag,
                    uid: tpl_type === 'comment' ? commentUid : uid,
                    poiUid: uid,
                    poiX: x,
                    poiY: y,
                    former_source
                };
                item.user_info = user_info;
                // 历史数据层级问题，有两个user_info，todo：两个是否可以合并
                item.origin_user_info = item.user_info;
                item.author = author;
                item.poilistTitle = title;
                item.comment_num = tpl_type === 'comment' ? num : comment_num;
                item.goTalosLink = baseMapButton.detailUrl || '';
                item.levelOne = levelOne;
                item.levelTwo = levelTwo;
                item.strategyInfo = strategyInfo;
                item.tpSource = newtpSource || tpSource;
                item.push_src_id = pushScrId;
                item.isForewarning = Number(isQmyj) || 0;
                item.pushCategory = pushCategory;
                item.aiPush = aiPush;
                if (skus_data && skus_data.length) {
                    item.skuListShow = true;
                    item.skuDataList = skus_data;
                }
                if (rootState.url.dataType !== 'poicomment' && !rootState.login.isLogin) {
                    this.commit('login/setIsLogin', favorite.isLogin);
                }
                if (thirdUrl !== '') {
                    item.isIframePage = true;
                }
                if (rootState.url.dataType === 'poicomment') {
                    item.noteType = data_type;
                }
                if (rootState.url.abtest.includes('107530')) {
                    item.hotspot = hotspot;
                }
            });
            if (init) {
                commit('setDataList', {data, iframePreload: rootState.preload.isIframePre});
            }
            else if (!refreshBar) {
                commit('setDataList', {data: state.dataList.concat(data)});
            }
            else {
                // 刷新底部bar的数据
                commit('updateDataList',
                    {
                        dataIndex: index,
                        val: data[0],
                        iframePreload: rootState.preload.isIframePre && rootState.preload.IframeLink
                    }
                );
            }
        },
        async refreshBar({dispatch}, index, unique_id, type = 'feed') {
            dispatch('requireData', {pn: 0, unique_id, refreshBar: true, dataType: type}).then(date => {
                dispatch('handleData', {data: date, index, refreshBar: true});
            });
        },
        // 评论转笔记召回数据
        async getDataList({dispatch}, params) {
            dispatch('requireData', params).then(date => {
                dispatch('handleData', {data: date});
            });
        },
        // 更新请求参数
        updateReqParams({rootState}, data) {
            // 笔记类型，评论转笔记不参与互动信号优化实验
            const dataType = this.getters['url/dataType'];

            const source = rootState.url.source;
            const abtest = rootState.url.abtest;
            // 是否不参与互动信号优化实验
            const flag = ['slide_detail', 'poi_main'].includes(source) && abtest.includes('107144');

            // 如果是评论转的笔记，或者满足不参与互动信号优化实验的条件，则不修改请求参数
            if (dataType === 'poicomment' || flag) {
                return;
            }
            const {unique_id, mentioned} = data || {};
            const {content = []} = mentioned || {};
            const {uid = ''} = content && content.length && content[0].bury || {};
            this.commit('url/setUid', uid);
            this.commit('url/setFirstUnique_id', unique_id);
        },

        // 预加载底部按钮展开动画
        handleSpaceCompress({commit}, val) {
            const tid = setTimeout(() => {
                commit('setSpaceCompressFoldPart', val);
            }, 0);

            document.addEventListener('touchstart', () => {
                commit('setSpaceCompressFoldPart', val);
                clearTimeout(tid);
            });
        },

        // 微信环境戳点后更新笔记信息
        async updateArticleData({commit, rootState}, value) {
            commit('setMapFeedFinished', false);
            const {loc_x = '', loc_y = ''} = rootState.url.pointPosition;
            if (loc_x && loc_y) {
                const [x1, y1, x2, y2] = getPointBound(loc_x, loc_y, 2000);
                const mapBound = `(${x1},${y1},${x2},${y2})`;
                commit('setMapBound', mapBound);
            }

            if (value.isFromMap) {
                const {bound = '', pointObj = {}, isFromMap = false} = value;
                commit('setFromMap', isFromMap);
                commit('setMapBound', bound);
                this.commit('url/setWxShareUid', pointObj.uid);

                const {lng = '', lat = ''} = pointObj.position || {};
                this.commit('url/setPointPosition', {
                    loc_x: lng,
                    loc_y: lat
                });
                commit('setPn', 0);
                // 端外笔记戳点后重置携程iframe index
                this.commit('iframe/setIframeIndexStr', {type: 'delete', index: ''});
                this.commit('iframe/setReportingStr', {type: 'delete', index: ''});
                const res = await getShareData({wxShareUid: rootState.url.wxShareUid});
                // 更新poi数据
                commit('setMicroPoiDetail', res.microPoiDetail);
            }
        }
    }
};